import { post } from "./request";

/**
 * 积分与充值接口（API 文档第 5 节 /console/credits）。
 */

export interface RechargeParams {
  amountCents: number;
  paymentMethodId: string;
  orderNo: string;
}

/** POST /credits/recharge 的返回（三种状态） */
export interface RechargeResult {
  status: "succeeded" | "requires_action" | "requires_payment_method";
  orderNo: string;
  amountCents?: number;
  newPurchasedCreditsCents?: number;
  newTotalBalanceCents?: number;
  clientSecret?: string;
  message?: string;
}

/** POST /credits/recharge */
export function rechargeCredits(
  params: RechargeParams
): Promise<RechargeResult> {
  return post<RechargeResult>("/credits/recharge", params);
}
